import { createSlice } from '@reduxjs/toolkit'

import { initialState } from './constants'
import { getCulturesThunk } from './thunks'

const culturesSlice = createSlice({
  name: 'cultures',
  initialState,
  reducers: {
    setCulturesReady: (state) => {
      state.ready = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCulturesThunk.fulfilled, (state, action) => {
      state.cultures = action.payload
      state.ready = true
    })
  },
})

export const { setCulturesReady } = culturesSlice.actions
export default culturesSlice.reducer
